import { useEffect } from "react";

/**
 * Full-screen image viewer. Rendered when `src` is non-null; click anywhere
 * or press Esc to close. Used for event cover photos so a thumbnail on the
 * card can open to full size.
 */
export function Lightbox({ src, onClose }: { src: string | null; onClose: () => void }) {
  useEffect(() => {
    if (!src) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    // Lock background scroll while open.
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [src, onClose]);

  if (!src) return null;

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 z-[2000] bg-black/85 flex items-center justify-center p-4"
    >
      <img
        src={src}
        alt=""
        className="max-w-full max-h-full object-contain rounded-lg"
        onClick={(e) => e.stopPropagation()}
      />
      <button
        type="button"
        onClick={onClose}
        aria-label="Close"
        className="absolute top-4 end-4 w-10 h-10 rounded-full bg-white/15 text-white text-[24px] leading-none flex items-center justify-center"
      >
        ×
      </button>
    </div>
  );
}
